import Collection from "../../data-structures/collection";

import {CustomFieldAccess, CustomFieldScope} from "./@const";
import SessionCustomField from "./session-custom-field";


export default class SessionCustomFields extends Collection<SessionCustomField> {

    constructor(customFields:SessionCustomField[]=[]) {
        super(customFields)

        // this.onChangeBusEvent = BUS_DEPARTMENTS_CHANGED
    }

    // Ampersand methods
    filter(filterFunc:func):SessionCustomField[] {
        return _.filter(this.models, filterFunc) as SessionCustomField[]
    }

    map(mapFunc:(item: SessionCustomField) => any):SessionCustomField[] {
        return _.map(this.models, mapFunc) as SessionCustomField[]
    }

    //

    sort() {
        this.models = _.sortBy(this.models, 'sortPosition')
    }

    resetFromJson(data:JSONArray):void {

        const models : SessionCustomField[] = []
        _.map(data, (record:JSONObject)=>{
            const model = new SessionCustomField(record)
            models.push(model)
        })

        return this.reset(models)

    }

    filterByCompany(companyId:ID, includeDeleted = false):SessionCustomFields {


        const models : SessionCustomField[] = this.filter((m)=>m.companyId === companyId && (!m.isDeleted || includeDeleted))

        const collection = new SessionCustomFields(models)
        collection.sort()

        return collection
    }


    exportOptions(): { value:ID, label:string, icon:string, access: CustomFieldAccess, scope: CustomFieldScope[], sortPosition:number }[] {

        const goodFields:SessionCustomField[] = this.filter((customField:SessionCustomField)=> {
            return !customField.isDeleted && gd.const.customFields[customField.type]
        }) as SessionCustomField[]


        return goodFields.map((customField:SessionCustomField)=>{
            return {
                value       : customField.id,
                label       : customField.name,
                icon        : customField.icon,
                access      : customField.access,
                sortPosition    : customField.sortPosition,
                scope       : _.get(customField.params, 'scope', [CustomFieldScope.TASK])
            }
        })
    }

    resetByCompany(companyId:ID,newData:any):void {
        const oldModels = this.filter((taskType)=>{
            return taskType.companyId === companyId;
        });

        _.each(oldModels,(model:SessionCustomField)=>{
            this.remove(model.id)
        });

        _.map(newData,(record:any)=>{
            this.add(new SessionCustomField(record))
        })

    }


    filterByName(name:string, lowerCase = true):SessionCustomField[] {
        return this.filter(m=>(lowerCase ? m.name.toLowerCase() : m.name) === name);
    }

    taskAndProject():SessionCustomFields {

        const models : SessionCustomField[] = this.filter((m)=>{
            return m.companyId === gd.companyId && !m.isDeleted && !_.isEqual(_.get(m,'params.scope'), [3])
        })

        const collection = new SessionCustomFields(models)
        collection.sort()

        return collection
    }

    resetAndMarkOldModelsAsDeleted(data:JSONArray, companyId?:ID) {

        const previousCollectionModels = _.clone(this.models)



        // if (companyId) {
        //     this.resetByCompany(companyId, data)
        // } else {
        //     this.reset(data, {parse:true})
        // }
        this.resetFromJson(data)

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, (model:SessionCustomField) => {
            if (!this.get(model.id)) {
                model.isDeleted = true
                this.add(model)
            }
        })
    }

    // Not in use anymore
    // exportItems():any[] {
    //     return this.map((model)=>{
    //         return {
    //             'value': model.id,
    //             'label': model.name
    //         }
    //     });
    // }



}


